import { OnInit } from '@angular/core';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { DeleteCommunicationComponent } from '../delete-communication/delete-communication.component';
var CommunicationCardComponent = /** @class */ (function () {
    function CommunicationCardComponent(_toggleService, _snackBar, _editCommDialog, _deleteCommDialog) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editCommDialog = _editCommDialog;
        this._deleteCommDialog = _deleteCommDialog;
    }
    CommunicationCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    Object.defineProperty(CommunicationCardComponent.prototype, "sortedFlightComms", {
        get: function () {
            return this.flightComms.sort(function (obj1, obj2) {
                if (obj1.service.toUpperCase() < obj2.service.toUpperCase()) {
                    return -1;
                }
                if (obj1.service.toUpperCase() > obj2.service.toUpperCase()) {
                    return 1;
                }
                if (obj1.sector === null && obj2.sector !== null) {
                    return -1;
                }
                if (obj1.sector !== null && obj2.sector === null) {
                    return 1;
                }
                if (obj1.sector < obj2.sector) {
                    return -1;
                }
                if (obj1.sector > obj2.sector) {
                    return 1;
                }
                if (obj1.frequency < obj2.frequency) {
                    return -1;
                }
                if (obj1.frequency > obj2.frequency) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    CommunicationCardComponent.prototype.openEditCommDialog = function (comm) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogRef = this._editCommDialog.open(EditCommunicationComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                isNew: false,
                comm: comm
            }
        });
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            }
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            if (isUpdated.success) {
                _this._snackBar.open('Communication', 'Updated', {
                    duration: 2000
                });
                if (isUpdated.newComm != null) {
                    _this._snackBar.open('New Frequency', 'Added', {
                        duration: 2000
                    });
                    _this.flightComms.push(isUpdated.newComm);
                }
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    CommunicationCardComponent.prototype.removeDeletedComm = function (commId) {
        var index = this.flightComms.findIndex(function (c) { return c.flightCommId === commId; });
        if (index > -1) {
            this.flightComms.splice(index, 1);
        }
    };
    CommunicationCardComponent.prototype.deleteComm = function (comm) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            commId: comm.flightCommId,
            airportId: comm.airportId,
            frequencyId: comm.frequencyId
        };
        var dialogRef = this._deleteCommDialog.open(DeleteCommunicationComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.removeDeletedComm(isUpdated.commId);
                _this._snackBar.open('Communication', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return CommunicationCardComponent;
}());
export { CommunicationCardComponent };
